import React from 'react';
import {Field, useFormikContext} from 'formik';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import SatisfactionButtons from 'shared/components/satisfaction-buttons';
import styles from './satisfaction.module.scss';
import {findIndex} from 'lodash';
import {Answer, Question} from '../types';

const SatisfactionQuestion = (props: {question: Question}): React.ReactElement => {
  const {values} = useFormikContext<{answers: Answer[]}>();
  const index = findIndex(values.answers, {questionId: props.question._id});

  return (
    <BaseStep stepHeader={props.question.text} subHeader={props.question.subheading}>
      <div className={styles.container}>
        <Field name={`answers[${index}].content`} id={props.question.identifier} type="text">
          {({field: {name, value}, form: {setFieldValue}}) => (
            <SatisfactionButtons
              onClick={(text) => () => setFieldValue(name, text)}
              satisfaction={value}
              trackPrefix="undergrad-survey"
            />
          )}
        </Field>
      </div>
    </BaseStep>
  );
};

export default SatisfactionQuestion;
